// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Calendar from '@sbmdkl/nepali-datepicker-reactjs';

export default Calendar;
